export const panelTheme = {
  border: {
    color: '{sd.border.lighter}'
  },

  background: '{sd.backgrounds.primary}',

  header: {
    padding: '4px 8px 0 8px'
  },

  content: {
    padding: '8px'
  }
};
